import imageCompression from 'browser-image-compression';

export interface CompressionOptions {
  maxSizeMB?: number;
  maxWidthOrHeight?: number;
  initialQuality?: number;
}

export const compressImage = async (file: File, customOptions?: CompressionOptions): Promise<File> => {
  // Only compress images
  if (!file.type.startsWith('image/')) {
    return file;
  }

  const options = {
    maxSizeMB: customOptions?.maxSizeMB ?? 2, // Allow up to 2MB for high-quality 2k images
    maxWidthOrHeight: customOptions?.maxWidthOrHeight ?? 2048, // Match backend's 2048px limit
    useWebWorker: true,
    fileType: file.type,
    initialQuality: customOptions?.initialQuality ?? 0.85, // Match backend's 85% quality
  };

  try {
    const compressedFile = await imageCompression(file, options);
    
    // console.log(`📸 Compressed ${file.name}: ${(file.size / 1024 / 1024).toFixed(2)}MB -> ${(compressedFile.size / 1024 / 1024).toFixed(2)}MB`);

    // If compression somehow results in a larger file (rare but possible with low quality originals), return original
    if (compressedFile.size > file.size) {
        return file;
    }

    // Ensure we return a File object with the original name
    // browser-image-compression might return a Blob which FormData sees as "blob"
    return new File([compressedFile], file.name, { type: compressedFile.type });
  } catch (error) {
    console.error('Image compression failed:', error);
    return file; // Return original file if compression fails
  }
};
